import {useEffect, useState} from 'react';
import {isLoggedIn} from "../utils/authUtils";
import {PrepaidSettingTypes} from "../types/transaction/prepaid.setting.types";
import {getMemberChargeSetting} from "../api/transaction/chargeApi";

export const usePrepaidSetting = () => {

    //TODO: 선수금 설정 가져오기 hook

    const [prepaidSetting, setPrepaidSetting] = useState<PrepaidSettingTypes>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getChargeSetting = async () => {
        const isAuth = isLoggedIn();

        if (isAuth) {
            try {
                setLoading(true);
                setError(null);
                const response = await getMemberChargeSetting();
                if (response.data?.code == "00") {
                    setPrepaidSetting(response.data.data);
                }
            } catch (err) {
                console.error('Failed to fetch getChargeSetting:', err);
                setError('설정을 불러오는데 실패했습니다.');
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        getChargeSetting();
    }, []);

    return {
        prepaidSetting,
        loading,
        error
    };

};